export const SignupFailureAction = { type: "ERROR" };
export const SignupLoading = { type: "LOADING" };
export const SignupSuccess = { type: "SUCCESS" };

